module.exports = __webpack_public_path__ + "img/phone-icon.264e3a9f.png";